import React, { Suspense, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useAppModernisation from "./hooks/useAppModernisation";
import { useFindInPageHighlighter } from "./hooks/FindInPageHooks/useFindInPageHighlighter";
import { useTableOfContentsScroll } from "./hooks/tableOfContentsHooks/useTableOfContentsScroll";
import { useOpenInModalRender } from "./hooks/OpenInModalHooks/useOpenInModalRender";
import { useDispatch } from "react-redux";
import { setIsAppMode } from "./features/counter/counterSlice";
import LoginAlertDialog from "./features/appMode/LoginAlertDialog";

const NavBar = React.lazy(() => import("./components/navBar"));
const MainContent = React.lazy(() => import("./components/mainContent"));
const TopicBanner = React.lazy(() => import("./components/topicBanner"));


const TopicToolsSticky = React.lazy(
  () => import("./components/topicToolsSticky")
);
const Footer = React.lazy(() => import("./components/footer"));

const App = () => {
  const navigate = useNavigate();
  const { isAppMode } = useAppModernisation();
  const contentRef = useRef(null);
  useFindInPageHighlighter(contentRef);
  useTableOfContentsScroll(contentRef);
  useOpenInModalRender(contentRef);
  const dispatch = useDispatch();
  dispatch(setIsAppMode(isAppMode));

  return (
    <>
      <Suspense fallback={<div className="loader"></div>}>
        <LoginAlertDialog />
        <NavBar push={navigate} />
        <TopicBanner push={navigate} />
        <MainContent ref={contentRef} />
        <TopicToolsSticky />
        {!window.Microsoft && !isAppMode && <Footer />}
      </Suspense>
    </>
  );
};

export default App;
